/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { AuthGuard } from '../auth.guard';

import { AutomateComponent } from '../automate/automate.component';
import { SkillListComponent } from '../automate/skill-list/skill-list.component';
import { SkillDetailComponent } from '../automate/skill-detail/skill-detail.component';

export const automateRouterConfig = [
  {
    path: 'automate',
    component: AutomateComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Automate', uiTitle: 'Automate' }
  },
  {
    path: 'automate/skills',
    component: SkillListComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Automate Skills', uiTitle: 'Automate Skills' }
  },
  {
    path: 'automate/:id',
    component: SkillDetailComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Automate Skill', uiTitle: 'Automate Skill' }
  }
];



// WEBPACK FOOTER //
// ./client/app/routes/automate.routes.ts